// extracted by mini-css-extract-plugin
module.exports = {"status":"Submissions_status__132th","success":"Submissions_success__3zI9h","error":"Submissions_error__2VwfY","failed":"Submissions_failed__tXQqG"};